module.exports = __webpack_public_path__ + "img/welding-9.bf70e010.jpg";